import React, { useEffect, useMemo, useState } from 'react'
import { AttributeDetailRenderer, Attributes } from '@leverege/ui-attributes'
import { Context } from '@leverege/plugin'
import { GlobalState } from '@leverege/ui-redux'

import SpatialView from './SpatialView'
import Constants from '../../../../util/Constants'

import S from './SegmentImageDetailRenderer.css'

export default class SegmentImageDetailRenderer extends AttributeDetailRenderer {
  getComponents( object, cxt ) {
    const value = Attributes.get( this.detail.attrName, object, cxt )

    return [
      {
        component : <SegmentImageRenderer context={cxt} value={value} object={object} />
      }
    ]
  }
}

function SegmentImageRenderer( props ) {
  const { context, object } = props
  const { clientProps, imageView } = context
  const { delegate, eventsPaginator, selected, rollover } = clientProps
  const [ src, setSrc ] = useState()
  const target = Context.getTarget( context )

  useEffect( () => {
    const rsrc = delegate.item( target.id ).resource( `resourceImage/images/${imageView}` ).getRsrc( GlobalState.get() )
    if ( rsrc ) {
      const url = new URL( rsrc.data.url )
      const expires = url.searchParams.get( 'Expires' )
      const expiresDate = new Date( parseInt( expires ) * 1000 )

      if ( expiresDate > new Date() ) {
        if ( rsrc.data.url !== src ) {
          setSrc( rsrc.data.url )
        }
        return
      }
    }

    GlobalState
      .dispatch( delegate.item( target.id ).resource( `resourceImage/images/${imageView}` ).get() )
      .then( ( res ) => {
        setSrc( res.data.url )
        return res
      } )
  }, [ target.id, imageView, src, delegate ] )

  const items = useMemo( () => {
    return eventsPaginator.pageItems
      .filter( ( item ) => {
        return item?.data?.data?.segmentId === object.id
      } )
  }, [ eventsPaginator.pageItems, object.id ] )

  return (
    <div
      className={S.container}>
      <img
        style={{
          height : Constants.SHELF_MONITORING_IMAGE_SIZE.segment.thumbnail.height,
          width : Constants.SHELF_MONITORING_IMAGE_SIZE.segment.thumbnail.width
        }}
        src={src}
        alt={src} />
      <SpatialView
        items={items}
        selected={selected}
        rollover={rollover} />
    </div>
  )
}
